import Com from '../detail';
import CrowdFundingPC from '@/components/CrowdFunding';
import { useGlobal } from '@/utils/useGlobal';
import { bundleData } from '@/data/crowdfunding/blade';
import { ACTIVITY_MAP } from '@/constants/blade';

export default function CrowdFunding({ productDetail, resProductCatagory, nowSysTime, supportData, crowdfundingTimeline, tabChange }: any) {
    const { useRouter, useLang, Link } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('bladeroboticlawnmower');
    const bundlesData = bundleData[locale] || bundleData.us;
    const activityId = ACTIVITY_MAP[locale] || ACTIVITY_MAP.us;

    const calObj: any = {
        link: '/blade-robotic-lawn-mower-checklist',
        btn: t('crowdfunding.header.calculator'),
    };
    const bannerData = {
        // 1.EFPic 2.Image 建议1
        swiperImgs: [
            `/media/blade/crowdfunding/pc/banner1.jpg`,
            `/media/blade/crowdfunding/pc/banner2.jpg`,
            `/media/blade/crowdfunding/pc/banner4.jpg`,
            `/media/blade/crowdfunding/pc/banner5.jpg`,
            `/media/blade/crowdfunding/pc/banner3.jpg`,
        ],
        webpUrl: '',
        subTitle: '',
        title: t('crowdfunding.header.title'),
        desc: t('crowdfunding.header.desc'),
        productKey: 'blade',
        showTC: ['us', 'ca'].includes(locale), // 是否显示问号 T&C内容弹窗
        note: t('crowdfunding.header.mother_day'), // 0506 @陈琨要求加一个母亲节促销文案
    };

    const shopifyBtnProps = {
        /// domain & token
        options: (() => {
            const map: any = {};
            return map[locale] || null;
        })(),
        // 购物车
        cartText: {
            title: t('crowdfunding.shopify_btn.title'),
            total: t('crowdfunding.shopify_btn.total'),
            empty: t('crowdfunding.shopify_btn.empty'),
            notice: t('crowdfunding.shopify_btn.notice'),
            button: t('crowdfunding.shopify_btn.button'),
        },
    };
    return (
        <div className="blade-crowdfunding">
            <CrowdFundingPC
                productDetail={productDetail}
                resProductCatagory={resProductCatagory}
                nowSysTime={nowSysTime}
                bundlesData={bundlesData}
                supportData={supportData}
                bannerData={bannerData}
                crowdfundingTimeline={crowdfundingTimeline}
                shopifyBtnProps={shopifyBtnProps}
                activityId={activityId}
                isPreOrder={['ca'].includes(locale)}
                Com={Com}
                showCalculator={calObj}
                tabChange={(val: string) => {
                    tabChange(val);
                }}
            />
            <style jsx global>
                {`
                    .product_naver {
                        display: none;
                    }
                `}
            </style>
        </div>
    );
}
